/* src/app/modules/shared/components/fab-menu/fab-menu.component.scss */
.fab-container {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}
.fab-container > div {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin-bottom: 5px;
}
.fab-buttons ::ng-deep button {
  margin-bottom: 17px;
}
.fab-toggler {
  float: right;
  z-index: 100;
}
/*# sourceMappingURL=fab-menu.component.css.map */
